import { render, staticRenderFns } from "./homeH5.vue?vue&type=template&id=6ae3c21c&scoped=true"
import script from "./homeH5.vue?vue&type=script&lang=js"
export * from "./homeH5.vue?vue&type=script&lang=js"
import style0 from "./homeH5.vue?vue&type=style&index=0&id=6ae3c21c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3c21c",
  null
  
)

export default component.exports